import type { Competition, RoundPhase, Team, Translated } from '@uefadigital/panenka';

import type { Enum } from './enum.types';

export const CoefficientRange = {
  OVERALL: 'OVERALL',
  SEASONAL: 'SEASONAL',
} as const;
export type CoefficientRange = Enum<typeof CoefficientRange>;

export const CoefficientType = {
  MEN_CLUB: 'MEN_CLUB',
  MEN_ASSOCIATION: 'MEN_ASSOCIATION',
  WOMEN_CLUB: 'WOMEN_CLUB',
  WOMEN_ASSOCIATION: 'WOMEN_ASSOCIATION',
  MEN_CLUB_TEN_YEARS: 'MEN_CLUB_TEN_YEARS',
  FUTELO: 'FUTELO',
} as const;
export type CoefficientType = Enum<typeof CoefficientType>;

export const CoefficientTrend = {
  DOWN: 'DOWN',
  STABLE: 'STABLE',
  UP: 'UP',
} as const;
export type CoefficientTrend = Enum<typeof CoefficientTrend>;

type Ranking = {
  totalPoints?: number;
  totalValue?: number;
  nationalAssociationPoints?: number;
  numberOfMatches?: number;
  numberOfTeams?: number;
  numberOfTeamsStillInPlaying?: number;
  position?: number;
};

export type OverallRanking = Ranking & {
  targetSeasonYear?: number;
  baseSeasonYear?: number;
  trend: CoefficientTrend;
};

export type SeasonRanking = Ranking & {
  factorTotalBonus?: number;
  seasonYear?: number;
  totalPointsWithBonus?: number;
};

export type Coefficient = {
  overallRanking?: OverallRanking;
  seasonRankings?: SeasonRanking[];
  member: Translated<Team> & {
    history?: Array<
      Translated<Team> & {
        fromDate: string;
        toDate: string;
        fromYear: number;
        toYear: number;
        inheritTeamId: string;
        fromPhase: RoundPhase[];
        toPhase: RoundPhase[];
      }
    >;
  };
  competition: Competition;
};

export type CoefficientResponse = {
  members: Coefficient[];
  lastUpdateDate?: string;
};
